// 被嵌入1. 采销工作台 2. 客服系统 3. c2b
function beInjectedInIframe() {
  return window.parent !== window && (window.name || true);
}

function isInC2B() {
  // return true;
  return beInjectedInIframe() === 'c2b';
}

export { beInjectedInIframe, isInC2B };
